import { getTargetByValue } from '@/blocks/Scraper/constants/targets';
import { TargetIcon } from '@/blocks/Scraper/TargetIcon';
import { DropdownOption } from '@/components/atoms/InputDropdownWithImage';
import { Text } from '@/components/atoms/Text';

import { useScraperTranslations } from '../scraperTranslations';

const ScraperSelectedOption = ({ option }: { option: DropdownOption }) => {
  const target = getTargetByValue(option.value);
  const { getTranslation } = useScraperTranslations();
  if (!target) return null;

  return (
    <li className='flex items-center gap-2 pl-0 ml-0 py-2'>
      <TargetIcon target={target} />
      <Text>{getTranslation(target.label) || ''}</Text>
    </li>
  );
};

export default ScraperSelectedOption;
